/* eslint-disable */
import { useRouteMatch } from 'react-router';
import { urls } from '../../Constants';
// eslint-disable-next-line object-curly-newline
import { RetailMenuListPage, CreateRetailMenu } from '../../Pages';
import CRUDRoutes from '../CRUD Routes/CRUD.routes';

const RetailMenuRoutes = () => {
	const { path } = useRouteMatch();
	const breadcrumbs = [
		{
			link: `${urls.EXTENSION}${urls.RETAIL_MENU}`,
			name: 'Retail Menu',
		},
	];
	return (
		<CRUDRoutes
			entity='RETAIL_MENU'
			path={path}
			listPage={RetailMenuListPage}
			viewPage={<CreateRetailMenu isEdit breadcrumbs={breadcrumbs} />}
			createPage={<CreateRetailMenu breadcrumbs={breadcrumbs} />}
			editPage={<CreateRetailMenu isEdit breadcrumbs={breadcrumbs} />}
		/>
	);
};

export default RetailMenuRoutes;
